export default "__VITE_ASSET__ec7ab2fc__"